import moment from 'moment'

const DATE_TIME_FORMAT_WITHOUT_TZD = 'YYYY-MM-DDThh:mm:ss'

export const resolveDateTimeByReplacingDotWithColon = (timeStringFromBackend: string) => {
  return timeStringFromBackend.replace('.', ':')
}

export const resolveDateTimeOmittingTimeZoneDesignator = (timeString: string) => {
  if (timeString.includes('+')) {
    return moment(timeString.split('+')[0], DATE_TIME_FORMAT_WITHOUT_TZD).format()
  }
  return timeString
}

export const isSameDateTime = (timeA: string | null, timeB: string | null) => {
  if (!timeA || !timeB) {
    return false
  }
  const momentA = moment(timeA)
  const momentB = moment(timeB)
  return momentA.year() === momentB.year()
    && momentA.month() === momentB.month()
    && momentA.date() === momentB.date()
    && momentA.hour() === momentB.hour()
    && momentA.minute() === momentB.minute()
}

export const isSameTime = (timeA: string | null, timeB: string | null) => {
  if (!timeA || !timeB) {
    return false
  }
  const momentA = moment(timeA)
  const momentB = moment(timeB)
  return momentA.hour() === momentB.hour()
    && momentA.minute() === momentB.minute()
}

export const isSameDate = (timeA: string | null, timeB: string | null) => {
  if (!timeA || !timeB) {
    return false
  }
  const momentA = moment(timeA)
  const momentB = moment(timeB)
  return momentA.year() === momentB.year()
    && momentA.month() === momentB.month()
    && momentA.date() === momentB.date()
}

export const getDateTimeDetails = (timeString: string) => {
  const time = moment(timeString)
  return {
    year: time.year(),
    month: time.month(),
    day: time.date(),
    hour: time.hour(),
    minute: time.minute(),
  }
}
